import _includes from "lodash/includes";
import { getDisplayPages, getSubProductType, getProductAudience } from '../selectors/banking';
import { BANKING_SUB_PRODUCT_TYPES, PRODUCT_AUDIENCE_TYPE } from '../constants';
/**
 * Determines whether a banking entity should display in page context.
 *
 * @param   {Object} marketplaceEntity    The BNK entity
 * @param   {string} currentDisplayPage   The current display page
 *
 * @return  {boolean}                     If the entity should show
 */

export var shouldDisplayOnPage = function shouldDisplayOnPage(marketplaceEntity, currentDisplayPage) {
  return _includes(getDisplayPages(marketplaceEntity), currentDisplayPage);
};
/**
 * Determines Minimum Balance driver label depending on the sub-product type and product audience fields
 * @param   {Object} marketplaceEntity    The BNK entity
 * @return  {String} The label
 */

export var getMinimumBalanceLabel = function getMinimumBalanceLabel(offer) {
  switch (getSubProductType(offer)) {
    case BANKING_SUB_PRODUCT_TYPES.CD:
      return 'Minimum deposit';

    case BANKING_SUB_PRODUCT_TYPES.CASH_MANAGEMENT:
    case BANKING_SUB_PRODUCT_TYPES.CHECKING:
      {
        return getProductAudience(offer) === PRODUCT_AUDIENCE_TYPE.BUSINESS ? 'Min. account balance' : 'Minimum balance';
      }

    default:
      return 'Minimum balance';
  }
};